export default __webpack_public_path__ + "static/media/countdown.7d52718d.png";